/*=========================================================================================
  File Name: actions.js
  Description: Vuex Store - actions
  ----------------------------------------------------------------------------------------
  Item Name: Pre-Pulse
  
==========================================================================================*/
import axios from '../../axios.js'
import router from '../../router.js'
import jwtDecode from 'jwt-decode'
const moment = require('moment') // require
const clonedeep = require('lodash.clonedeep')

const actions = {

  ActionGetOpenBatches({state, commit, dispatch}){
    return new Promise((resolve, reject) => {
      axios.get('prepulse/batch/open')
        .then(response => {
          console.log("Open batches response: ", response.data)
          commit("SetOpenBatchesList", response.data.oData)
          // commit("SetBatchStatesList", response.data.oData.BatchStates)
          resolve(response)
        })
        .catch(error => {
          dispatch("ActionCheckError", error, { root: true })
          reject(error)
        })
    })
  },

  ActionGetOpenBatchStates({state, commit, dispatch}, payload){
    return new Promise((resolve, reject) => {
      axios.get('prepulse/batch/open/states?BatchID='+payload)
        .then(response => {
          console.log("Open batch states response: ", response.data)
          commit("SetBatchStatesList", response.data.oData)
          resolve(response)
        })
        .catch(error => {
          dispatch("ActionCheckError", error, { root: true })
          reject(error)
        })
    })
  },

  ActionGetIncidentClaims({state, commit, dispatch}, payload){
    return new Promise((resolve, reject) => {
      axios.get('prepulse/claim?IncidentID=' + payload)
        .then(response => {
          console.log("Incident Claims response: ", response.data)
          commit("SetIncidentClaims", response.data.oData)
          resolve(response)
        })
        .catch(error => {
          dispatch("ActionCheckError", error, { root: true })
          reject(error)
        })
    })
  },

  ActionGetIncidentSupplements({state, commit, dispatch}, payload){
    // return new Promise((resolve, reject) => {
    //   axios.get('prepulse/incident/supplements?IncidentID=' + payload)
    //     .then(response => {
    //       console.log("Incident supplements response: ", response.data)
    //       commit("SetIncidentSupplements", response.data.oData)
    //       resolve(response)
    //     })
    //     .catch(error => {
    //       dispatch("ActionCheckError", error, { root: true })
    //       reject(error)
    //     })
    // })
  },

  ActionSaveIncidentClaim({state, commit, dispatch}, payload){
    return new Promise((resolve, reject) => {
      axios.post('prepulse/claim', payload)
        .then(response => {
          console.log("Incident claim create response ", response.data)
          dispatch("ActionGetIncidentClaims", payload.IncidentID)
          resolve(response)
        })
        .catch(error => {
          dispatch("ActionCheckError", error, { root: true })
          reject(error)
        })
    })
  },


  ActionDeleteIncidentClaim({state, commit, dispatch}, payload){
    return new Promise((resolve, reject) => {
      axios.post('prepulse/claim/delete?ClaimID='+ payload.ClaimID)
        .then(response => {
          console.log("Delete incident claim response ", response.data)
          dispatch("ActionGetIncidentClaims", payload.IncidentID)

          resolve(response)
        })
        .catch(error => {
          dispatch("ActionCheckError", error, { root: true })
          reject(error)
        })
    })
  },




  ActionGetNextClaim({state, commit, dispatch}, payload){
    return new Promise((resolve, reject) => {
      axios.get('prepulse/batch/nextclaim?BatchID='+payload.BatchID + "&StateOfLoss=" + payload.StateOfLoss)
        .then(response => {
          console.log("next claim data ", response.data)
          // this.dispatch("ActionGetIncident", response.data.oData.IncidentID)
          // this.dispatch("ActionGetIncidentClaims", response.data.oData.IncidentID)

          resolve(response.data.oData)
        })
        .catch(error => {
          dispatch("ActionCheckError", error, { root: true })
          reject(error)
        })
    })
  },

  ActionGetIncident({state, commit, dispatch}, payload){
    return new Promise((resolve, reject) => {
      axios.get('prepulse/incident?IncidentID=' + payload)
        .then(response => {
          console.log("Incident data ", response.data)
          commit("SetIncident", response.data.oData)

          resolve(response)
        })
        .catch(error => {
          dispatch("ActionCheckError", error, { root: true })
          reject(error)
        })
    })
  },

  ActionSaveIncident({state, commit, dispatch}, payload){
    var payload = clonedeep(payload)
    //payload.DateOfLoss = moment(payload.DateOfLoss, "")
    console.log(payload)
    return new Promise((resolve, reject) => {
      axios.post('prepulse/incident', payload)
        .then(response => {
          
          console.log("Incident data ", response.data)

          resolve(response)
        })
        .catch(error => {
          dispatch("ActionCheckError", error, { root: true })
          reject(error)
        })
    })
  },


  ActionGetHoldIncidents({state, commit, dispatch}){
    return new Promise((resolve, reject) => {
      axios.get('prepulse/batch/holdincidents')
        .then(response => {
          console.log("hold incidents response: ", response.data)
          commit("SetMyHoldList", response.data.oData)
          resolve(response)
        })
        .catch(error => {
          dispatch("ActionCheckError", error, { root: true })
          reject(error)
        })
    })
  }
}

export default actions
